import { E_BEHAVIOR } from './route.types';
export const behavior = [
    {
        path: '/dashboard',
        name: E_BEHAVIOR.DashBoard,
        redirect: {
            name: E_BEHAVIOR.GlobalViewBoard,
        },
        component: () => import(/* webpackChunkName: "customerBoard" */ '../../views/behavior/Dashboard/Dashboard.vue'),
        children: [
            {
                name: E_BEHAVIOR.ActiveBoard,
                path: 'charts',
                component: () => import(/* webpackChunkName: "customerBoard" */ '../../views/behavior/ActiveBoard/ActiveBoard.vue'),
                meta: {
                    permission: 'CustomerBoardCharts',
                },
            },
            {
                name: E_BEHAVIOR.GlobalViewBoard,
                path: 'globalView',
                component: () => import(/* webpackChunkName: "customerBoard" */ '../../views/behavior/GlobalViewBoard/GlobalViewBoard.vue'),
                meta: {
                    permission: 'GlobalViewList',
                },
            }
        ],
    }
];
/**
 * dashboard 页面级子菜单
 * 注意这里的顺序需要和菜单顺序保持一致
 */
export const DashboardRoutePermissionTable = [
    { name: E_BEHAVIOR.GlobalViewBoard, permission: 'GlobalViewList' },
    { name: E_BEHAVIOR.ActiveBoard, permission: 'CustomerBoardCharts' }
];
